export const EN = {
  // Navbar
  "Home": "Home",
  "Chi Siamo": "About",
  "Servizi": "Services",
  "Insights": "Insights",
  "Contatti": "Contact",
  "Area Riservata": "Client Area",
  "Il tuo Portale": "Your Portal",
  "Consulenza Strategica": "Strategic Advisory",

  // Footer
  "Studio": "The Firm",
  "Le Sedi": "Our Offices",
  "Sede Legale": "Registered Office",
  "Sede Operativa": "Operating Office",
  "News & Insights": "News & Insights",
  "Si riceve previo appuntamento": "By appointment only",
  "Modulo di richiesta riservata": "Confidential enquiry form",
  "Consulenza societaria, fiscale e operazioni straordinarie. Uno studio milanese a presidio diretto dei soci.":
    "Corporate, tax and extraordinary transaction advisory. A Milan boutique firm with direct partner involvement.",
  "Mediolanum Consulting Srl — P.IVA / C.F. 14419200960 — REA MI-2781751 — Cap. Soc. € 10.000,00 — Via Card. Branda Castiglioni 2/1, 20156 Milano":
    "Mediolanum Consulting Srl — VAT 14419200960 — REA MI-2781751 (Milan) — Share Capital € 10,000.00 — Via Card. Branda Castiglioni 2/1, 20156 Milan, Italy",
  "© 2026 Mediolanum Consulting Srl. Tutti i diritti riservati.":
    "© 2026 Mediolanum Consulting Srl. All rights reserved.",

  // Cookie banner
  "Rispettiamo la vostra riservatezza": "We respect your privacy",
  "Questo sito utilizza cookie tecnici necessari al funzionamento e, previo consenso, cookie di analisi anonima per migliorare l'esperienza di navigazione. Maggiori dettagli nella":
    "This website uses technical cookies required for operation and, with your consent, anonymous analytics cookies to improve your browsing experience. More details in our",
  "Solo necessari": "Strictly necessary",
  "Accetta tutti": "Accept all",

  // Marquee
  "Fiscalità Internazionale": "International Tax",
  "Ristrutturazioni del Debito": "Debt Restructuring",
  "Passaggio Generazionale": "Generational Transition",

  // Topics
  "Fisco": "Tax",
  "Giurisprudenza": "Case Law",

  // Insights UI
  "Tutti": "All",
  "Tutti gli articoli": "All articles",
  "Caricamento degli articoli…": "Loading articles…",
  "Impossibile caricare gli articoli": "Unable to load articles",
  "Leggi": "Read",

  // Login / Area riservata
  "oppure": "or",
  "Continua con Google": "Continue with Google",
  "Area Clienti Riservata": "Reserved Client Area",
  "Accesso al portale documentale e allo stato delle operazioni.":
    "Access the document portal and the status of your transactions.",
  "Accedi al Portale": "Sign in to the Portal",
  "Accesso in corso…": "Signing in…",
  "Verifica della sessione…": "Checking your session…",
  "Accesso effettuato": "Signed in",
  "Benvenuti nel portale riservato.": "Welcome to the reserved portal.",
  "Esci": "Log out",
  "Portale Cliente": "Client Portal",
  "Documenti Riservati": "Reserved Documents",
  "Nessun documento disponibile al momento. I documenti condivisi dallo studio appariranno qui.":
    "No documents available yet. Documents shared by the firm will appear here.",
  "Stato delle Operazioni": "Transaction Status",
  "Scarica": "Download",
  "Caricamento…": "Loading…",
  "Tutti i documenti sono trattati secondo i protocolli di riservatezza dello studio. Per nuovi incarichi contattate il vostro partner di riferimento.":
    "All documents are handled according to the firm's confidentiality protocols. For new engagements, please contact your reference partner.",
  "Download non riuscito": "Download failed",
};
